import { render, staticRenderFns } from "./basic-information.vue?vue&type=template&id=f61f827c&scoped=true&"
import script from "./basic-information.vue?vue&type=script&lang=js&"
export * from "./basic-information.vue?vue&type=script&lang=js&"
import style0 from "./basic-information.vue?vue&type=style&index=0&id=f61f827c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f61f827c",
  null
  
)

export default component.exports